var CONFUSEDCMS = CONFUSEDCMS || {};

(function ($) {

	CONFUSEDCMS.postCodeFromURL = function () {

		if (typeof URLSearchParams === 'function') {
			var input = jQuery('input[type="text"].js-get-a-quote-input');
			if (input) {
				var params = new window.URLSearchParams(window.location.search);
				input.val(params.get('postcode'));
			}
		}
	};

})(window.jQuery);
